import { Season } from '../../domain/models/season.model';
import { AppState } from '../app.state';
import { SeasonState } from './season.state';

export const getSeasonState = (state: AppState): SeasonState => state.season;

export const getSeasons = (state: AppState): Season[] => state.season.seasons;

export const getSeasonLoading = (state: AppState): boolean =>
  state.season.isLoading;

export const getSeasonError = (state: AppState): string | null =>
  state.season.error;

export const getSeasonNameWithId = (
  state: AppState,
  seasonId: string | null,
): string => {
  if (!seasonId) return 'Pick Season';
  const season = state.season.seasons.find(
    (season) => season.seasonId === seasonId,
  );
  return season ? season.seasonName : 'Pick Season';
};
